import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import './ProductColorPicker.less';


function ProductColorPicker(props) {
  const { colors, activeColor, maxColorsToShow, link, onSelect } = props;

  const visibleColors = (maxColorsToShow && colors.length > maxColorsToShow)
    ? colors.slice(0, maxColorsToShow)
    : colors;

  return (
    <div className="product-color-picker">
      {visibleColors.map(color => (
        <span
          key={color.value}
          className={`circle-wrapper${activeColor === color.value ? ' active' : ''}`}
          onClick={() => onSelect(color)}
        >
          <span
            className="circle back"
          />
          <span
            className="circle front"
            data-label={color.label}
            style={{ background: `#${color.value}` }}
          />
        </span>
      ))}
      {link && maxColorsToShow && (colors.length > maxColorsToShow) && (
        <Link className="zola-ui link more" to={link}>
          more
        </Link>
      )}
    </div>
  );
}

ProductColorPicker.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({})),
  activeColor: PropTypes.string,
  // small: PropTypes.bool,
  maxColorsToShow: PropTypes.number,
  link: PropTypes.string,
  onSelect: PropTypes.func,
};

export default ProductColorPicker;



// WEBPACK FOOTER //
// ./src/cards/components/common/ProductColorPicker/ProductColorPicker.jsx